import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AgentStatusControls = ({ currentStatus, onStatusChange }) => {
  const [isBreakMenuOpen, setIsBreakMenuOpen] = useState(false);

  const statusOptions = [
    {
      value: 'available',
      label: 'Müsait',
      icon: 'CheckCircle',
      color: 'success',
      description: 'Gelen aramaları kabul edebilir'
    },
    {
      value: 'busy',
      label: 'Meşgul',
      icon: 'XCircle',
      color: 'error',
      description: 'Aktif aramada veya işlem yapıyor'
    },
    {
      value: 'away',
      label: 'Uzakta',
      icon: 'Clock',
      color: 'warning',
      description: 'Kısa süreli uzakta'
    }
  ];

  const breakOptions = [
    { value: 'lunch', label: 'Öğle Molası', duration: '30 dk' },
    { value: 'coffee', label: 'Kahve Molası', duration: '15 dk' },
    { value: 'meeting', label: 'Toplantı', duration: '60 dk' },
    { value: 'training', label: 'Eğitim', duration: '120 dk' }
  ];

  const currentStatusInfo = statusOptions?.find(status => status?.value === currentStatus);

  const handleStatusChange = (newStatus) => {
    onStatusChange(newStatus);
  };

  const handleBreakStart = (breakType) => {
    onStatusChange('break', breakType);
    setIsBreakMenuOpen(false);
  };

  return (
    <div className="bg-white rounded-lg shadow-subtle border border-slate-200 p-6">
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-slate-900 mb-2">Ajan Durumu</h3>
        <p className="text-sm text-slate-600">Mevcut çalışma durumunuzu yönetin</p>
      </div>
      {/* Current Status Display */}
      <div className="mb-6 p-4 bg-slate-50 rounded-lg">
        <div className="flex items-center justify-center space-x-3 mb-2">
          <div className={`w-4 h-4 rounded-full ${
            currentStatusInfo?.color === 'success' ? 'bg-success pulse-slow' :
            currentStatusInfo?.color === 'error' ? 'bg-error' :
            currentStatusInfo?.color === 'warning' ? 'bg-warning' : 'bg-slate-400'
          }`} />
          <span className="text-lg font-semibold text-slate-900">
            {currentStatusInfo?.label || 'Bilinmiyor'}
          </span>
        </div>
        <p className="text-sm text-slate-600 text-center">
          {currentStatusInfo?.description || 'Durum bilgisi mevcut değil'}
        </p>
      </div>
      {/* Status Control Buttons */}
      <div className="space-y-3 mb-6">
        {statusOptions?.map((status) => (
          <Button
            key={status?.value}
            variant={currentStatus === status?.value ? "default" : "outline"}
            size="default"
            onClick={() => handleStatusChange(status?.value)}
            iconName={status?.icon}
            iconPosition="left"
            className="w-full justify-start"
          >
            {status?.label}
          </Button>
        ))}
      </div>
      {/* Break Controls */}
      <div className="border-t border-slate-200 pt-4">
        <div className="relative">
          <Button
            variant="outline"
            size="default"
            onClick={() => setIsBreakMenuOpen(!isBreakMenuOpen)}
            iconName="Coffee"
            iconPosition="left"
            className="w-full justify-start"
          >
            Mola Ver
            <Icon name="ChevronDown" size={16} className="ml-auto" />
          </Button>

          {/* Break Menu Dropdown */}
          {isBreakMenuOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-lg shadow-elevated border border-slate-200 py-2 z-10 fade-in">
              {breakOptions?.map((breakOption) => (
                <button
                  key={breakOption?.value}
                  onClick={() => handleBreakStart(breakOption)}
                  className="w-full text-left px-4 py-3 hover:bg-slate-50 flex items-center justify-between micro-hover"
                >
                  <span className="text-sm font-medium text-slate-900">
                    {breakOption?.label}
                  </span>
                  <span className="text-xs text-slate-500">
                    {breakOption?.duration}
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      {/* Quick Actions */}
      <div className="mt-6 pt-4 border-t border-slate-200">
        <div className="grid grid-cols-2 gap-3">
          <Button
            variant="outline"
            size="sm"
            iconName="Settings"
            iconPosition="left"
          >
            Ayarlar
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="HelpCircle"
            iconPosition="left"
          >
            Yardım
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AgentStatusControls;